















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import Timeline from '@/models/Timeline'
import ElementQueries from 'css-element-queries'
import draggable from 'vuedraggable'
import EventListElement from './EventListElement.vue'
import Mutations from '@/store/mutations'
import KeyListener from '../../KeyListener'
import Node from '@/models/Node'

@Component(
{
	components:
	{
        draggable,
		EventListElement
	},
	recomputed:
	{
		widthOffset()
		{
			let width = window.innerWidth;
			if (width * 0.2 < 350)
				return '-350px';
			return '-20vw';
		},
		hide_content()
		{
			let _this = this as EventListEditor;
			return _this.bHidden && (new Date().getTime() - _this.lastHidden.getTime()) > 0.5;
		}
	}
})
export default class EventListEditor extends Vue
{
	// Note(Ian): For some reason, naming this member _hidden caused it to be undefined for the computed properties.  I'll look into that more at some point - might
	// be a Vue thing bc I couldn't find anything that suggested Typescript itself would be the culprit (though I admittedly didn't put much time into investigating it)
	private bHidden = true;
	private lastHidden = new Date("1/1/1970");
	private focusedElement : EventListElement | undefined | null = null;
	private elementMap = new Map<Number, EventListElement>();
	
	get hidden()
	{
		return this.bHidden;
	}

	set hidden(value : boolean)
	{
		this.bHidden = value;
		this.lastHidden = new Date();
		setTimeout(() => {
			// Check in case the component is unmounted during the timeout
			if ((this as any).hide_content)
			{
				this.$recompute("hide_content");
			}
			else
			{
				(this.$refs.closeBtn as HTMLElement).focus();
			}
		}, 550);
	}

	resizeSensor : ElementQueries.ResizeSensor = <any>null

	orderingNeedsReload = false;

	unsubscribeFromMutations : any = null;

	mounted()
	{
		this.$nextTick(() =>
		{
			let timer = setInterval(()=>{
				if ((this.$refs.eventListEditor as HTMLDivElement) != null)
				{
					this.resizeSensor = new ElementQueries.ResizeSensor(this.$refs.eventListEditor as HTMLDivElement, () =>
					{
						this.$nextTick(() =>
						{
							this.$recompute('widthOffset');
						});
					});

					clearInterval(timer);
				}
			}, 100);
		});

		this.unsubscribeFromMutations = this.$store.subscribe((mutation : any, state : any) =>
		{
			if (mutation.type == Mutations.setTimelineEventOrdering)
			{
				let data = mutation.payload;
				if (data.timelineid === this.timeline.id)
				{
					this.orderingNeedsReload = !(this.orderingNeedsReload);
				}
			}
			else if (mutation.type === Mutations.notifyTagFilterUpdated)
			{
				this.orderingNeedsReload = !(this.orderingNeedsReload);
			}
		});

		KeyListener.addKeyHandler(this);

		this.rebuildElementMap();
	}

	beforeDestroy()
	{
		this.unsubscribeFromMutations();
		this.unsubscribeFromMutations = null;
		KeyListener.removeKeyHandler(this);
	}

    get selectedObject()
	{
		return this.$store.state.project.selected;
	}

    get selectedObjectOrderingIndex()
    {
        if (this.selectedObject && this.selectedObject.isEvent
            && this.selectedObject.isEvent() && this.selectedObject.nodeid)
        {
            return this.eventOrdering.indexOf(this.selectedObject.nodeid);
        }
        return -1;
    }

	get timeline() : Timeline
	{
		return this.$store.state.project.activeTimeline;
	}

	get eventOrdering() : number[]
	{
		if (this.timeline == null)
		{
			return [];
		}
		else
		{
    		let track = this.$store.state.project.nodesTracker;
			
			// Disabling filtering as it confuses reordering
			const cur = (((track && !track) || this.orderingNeedsReload) ? this.timeline.getEventOrdering() : this.timeline.getEventOrdering())
				// .filter(id=>{
				// 	if (!this.$store.getters.nodes.has(id)) return false;
            	// 	const n = this.$store.getters.nodes.get(id) as Node;
				// 	if (n.tags.length > 0)
				// 	{
				// 	    if (n.tags[0].filtered) return false;
				// 	}
				// 	return true;
				// });
			return cur;
		}
	}

	set eventOrdering(value : number[])
	{
		this.timeline.setEventOrdering(value);
		this.orderingNeedsReload = !this.orderingNeedsReload;
	}

	sendToTop(nodeid: number)
	{
	    this.timeline.changeEventOrdering(nodeid, 0);
		this.orderingNeedsReload = !this.orderingNeedsReload;
	}

	sendToBottom(nodeid: number)
	{
	    this.timeline.changeEventOrdering(nodeid, this.eventOrdering.length);
		this.orderingNeedsReload = !this.orderingNeedsReload;
	}

	insertAfterSelected(nodeid: number)
	{
	    if (this.selectedObjectOrderingIndex >= 0)
        {
            const currentIndex = this.eventOrdering.indexOf(nodeid);
            const newIndex = (currentIndex <= this.selectedObjectOrderingIndex)
                ? this.selectedObjectOrderingIndex
                : this.selectedObjectOrderingIndex + 1;
            this.timeline.changeEventOrdering(nodeid, newIndex);
		    this.orderingNeedsReload = !this.orderingNeedsReload;
        }
	}

	onChange(arg : any)
	{
		if (arg.moved != null)
		{
			this.timeline.changeEventOrdering(arg.moved.element, arg.moved.newIndex);
			this.orderingNeedsReload = !this.orderingNeedsReload;
		}
	}

	rebuildElementMap()
	{
		this.elementMap.clear();
		if(this.$refs.eventListElements != null)
		{
			for (const el of (this.$refs.eventListElements as EventListElement[]))
			{
				this.elementMap.set(el.nodeid, el);
			}
		}
	}

	show()
	{
		this.hidden = false;
	}

	focused(element : number)
	{
		this.focusedElement = this.elementMap.get(element);
		// console.log(`focus on ${this.focusedElement} (${element})`);
	}

	unfocused(element : number)
	{
		this.focusedElement = null;
	}

	refocus(element : any)
	{
		setTimeout(() =>
		{
			element.focus();
		}, 100);
	}

	moveFocusedBy(increment : number)
	{
		if (this.focusedElement != null)
		{
			let newInd = this.eventOrdering.indexOf(this.focusedElement.nodeid as number) + increment;
			this.refocus(this.focusedElement.$el);
			this.onChange(
			{
				moved:
				{
					element: this.focusedElement.nodeid,
					newIndex: newInd
				}
			});
		}
	}

	keyHandler(event : KeyboardEvent, isTextBoxFocused : boolean)
	{
		// console.log(this.focusedElement);
		if (!(KeyListener.isTabDown()) && this.focusedElement != null)
		{
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
			if (KeyListener.isArrowUpDown())
			{
				this.moveFocusedBy(-1);
			}
			else if (KeyListener.isArrowDownDown())
			{
				this.moveFocusedBy(1);
			}
			else if (KeyListener.isEnterDown() || KeyListener.isSpacebarDown())
			{
				this.refocus(this.focusedElement.$el);
				this.focusedElement.clicked();
			}
		}
	}
}
